import React from 'react';

const Iframe = ({src, height = '100%', width = '100%'}) => (
    <div style={{width, height}}>
        <iframe src={src} height={height} width={width} style={{border: 0}}/>
    </div>
);

export default Iframe;
